/* eslint-disable import/no-unresolved,import/no-duplicates,import/extensions */
import _ from 'lodash';
import { toDateStringOnly } from 'utils/dateUtil';
import { DEFAULT_CURRECY } from 'containers/FastCover/constants';

function covertCodeForLossOfIncome(claimCode) {
  const list = [
    {
      from: ['RO'],
      to: 'RI',
    },
    {
      from: ['KA'],
      to: 'KC',
    },
    {
      from: ['VA'],
      to: 'VC',
    },
  ];
  const rs = _.find(list, (x) => x.from.indexOf(claimCode) > -1);
  if (rs) {
    return rs.to;
  }
  return claimCode;
}

export function mapToAdditionalExpense(expense) {
  const shortDescription = `${expense.supplier} | ${expense.description}`;
  return {
    shortDescription,
    dateOfExpense: expense.dateOfExpense,
    clientCost: expense.amountPaid,
    currency: expense.amountPaidCurrency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}

export function mapToCancellationExpense(expense) {
  const shortDescription = `${expense.supplier} | ${expense.cancelledBookingDescription}`;
  return {
    shortDescription,
    dateOfExpense: expense.dateCancelled,
    clientCost: expense.prePaidAmount,
    currency: expense.prePaidAmountCurrency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}

export function mapToDelayedLuggageExpense(expense) {
  const shortDescription = `${expense.storeWhereItemWasPurchased} | ${expense.descriptionOfItem} | ${expense.purchasePrice} | ${expense.currency}`;
  return {
    shortDescription,
    dateOfExpense: expense.datePurchased,
    clientCost: expense.amountClaimed,
    currency: expense.amountClaimedCurrency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}

export function mapToMedicalExpense(expense) {
  const shortDescription = `${expense.nameOfDoctorOrProvider} | ${expense.treatmentReceived}`;
  return {
    shortDescription,
    dateOfExpense: expense.dateOfTreatment,
    clientCost: expense.didYouPayThisAmount ? expense.amountCharged : 0,
    currency: expense.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}

export function mapToAccidentalDeathExpense(data, claim) {
  if (data.areYouClaimingForAccidentalDeath !== 'true') {
    return [];
  }
  const { claimCode } = claim;
  return [{
    shortDescription: 'Accidental Death',
    dateOfExpense: data.insuredDateOfDeath,
    clientCost: 0,
    currency: DEFAULT_CURRECY.Symbol,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claimCode,
  }];
}

export function mapToLossOfIncomeExpense(data, claim) {
  if (data.areYouClaimingForLossOfIncome !== 'true') {
    return [];
  }
  const { claimCode } = claim;
  const shortDescription = `Loss of Income | ${toDateStringOnly(data.actualReturnToWorkDate)}`;
  return [{
    shortDescription,
    dateOfExpense: data.plannedReturnToWorkDate,
    clientCost: data.incomeLost,
    currency: DEFAULT_CURRECY.Symbol,
    rate: null,
    requestedAmount: null,
    claimTypeCode: covertCodeForLossOfIncome(claimCode),
  }];
}

export function mapToRentalVehicleExpense(data, claim) {
  return [{
    shortDescription: data.description,
    dateOfExpense: data.dateOfExpense,
    clientCost: data.amountClaimed,
    currency: data.amountClaimedCurrency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: claim.claimCode,
  }];
}

export function mapToSnowSportAdditionalItemExpense(expense) {
  const shortDescription = `${expense.storeWhereItemWasPurchased} | ${expense.descriptionOfItem} | ${expense.purchasePrice} | ${expense.currency}`;
  return {
    shortDescription,
    dateOfExpense: expense.datePurchased,
    clientCost: expense.amountClaimed,
    currency: expense.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}

export function mapToOtherExpense(expense) {
  return {
    shortDescription: expense.description,
    dateOfExpense: expense.dateOfExpense,
    clientCost: expense.amount,
    currency: expense.currency,
    rate: null,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}

export function mapToCancellationRefundCompensationItem(expense) {
  if (expense.refundCompensationReceived > 0) {
    return {
      shortDescription: `Refund: ${expense.cancelledBookingDescription}`,
      dateOfExpense: expense.dateRefundWasReceived,
      clientCost: (expense.refundCompensationReceived === 0) ? 0 : -expense.refundCompensationReceived,
      currency: expense.refundCompensationReceivedCurrency,
      rate: null,
      requestedAmount: null,
      claimTypeCode: this.claimCode,
    };
  }
  return null;
}

export function mapToDelayedTravelRefundCompensationItem(expense) {
  if (expense.amountRefunded > 0) {
    return {
      shortDescription: `Refund: ${expense.description}`,
      dateOfExpense: expense.dateRefundWasReceived,
      clientCost: (expense.amountRefunded === 0) ? 0 : -expense.amountRefunded,
      currency: expense.amountRefundedCurrency,
      rate: null,
      requestedAmount: null,
      claimTypeCode: this.claimCode,
    };
  }
  return null;
}


export function mapToDelayedTravelExpense(expense) {
  return {
    shortDescription: expense.description,
    dateOfExpense: expense.date,
    clientCost: expense.amount,
    currency: expense.amountCurrency,
    rate: 0,
    requestedAmount: null,
    claimTypeCode: this.claimCode,
  };
}



// WEBPACK FOOTER //
// ./app/containers/FastCover/dataMapper/expenseMapper.js